import './index.styl';
import template from './index.jst';

import _ from 'lodash';
import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';

import { Preloader } from "../../../utils";
import { User } from '../../../models';

const playerComparisonChannel = Radio.channel('player:comparison');

export class PlayerComparisonMain extends View {
	get template() {
		return template;
	}

	get className() {

		return 'player-comparison-page';
	}

	ui() {
		return {
			favourite: '.js-favourite-player',
			remove: '.js-remove-player',
		}
	}

	events() {
		return {
			'click @ui.favourite': 'onFavourite',
			'click @ui.remove': 'removePlayer',
		}
	}

	regions() {
		return {
			nav: '.js-navigation-region',
			board: '.js-board-region',
			chart: '.js-chart-region',
			stats: '.js-stats-box-region',
			aside: '.js-aside-region',
		}
	}

	initialize() {
		this.initListeners().requestData();
	}

	initListeners() {
		this.listenTo(this, 'data:requested', this.onDataRequested);
		this.listenTo(playerComparisonChannel, 'switch:to:multi:tab', this.switchToMulti);
		this.listenTo(playerComparisonChannel, 'switch:to:h2h:tab', this.switchToh2h);

		return this;
	}

	switchToMulti() {
		this.$el.addClass('coach-stats-tab');
	}

	switchToh2h() {
		this.$el.removeClass('coach-stats-tab');
	}

	get requestModels() {
		return _.pick(
			this.options,
			'squads', 'rounds', 'players',
			'venues', 'favourites',
			(User.has_assistant_coach ? 'coach' : null),
		)
	}

	requestData() {
		Preloader.show();

		const requests = _.invokeMap(this.requestModels, 'fetch');

		Promise.all(requests)
			.then(() => this.trigger('data:requested'))
			.then(Preloader.hide);

		return this;
	}

	onDataRequested() {
		const
			actual_round = this.options.rounds.actual,
			actual_round_json = actual_round.toJSON(),
			squads = this.options.squads.toJSON(),
			positions = this.options.positions.toJSON(),
			rounds = this.options.rounds.toJSON(),
			positions_by_id = _.keyBy(positions, 'id'),
			squad_by_id = _.keyBy(squads, 'id'),
			last_completed_round = this.options.rounds.last_completed,
			is_preseason = this.options.rounds.is_preseason,
			last_round = this.options.rounds.last_round,
			coach = User.has_assistant_coach ? this.options.coach.toJSON() : false,
			actual_round_id = actual_round.get('id'),
			bye_rounds = this.options.rounds.future_bye_rounds.map(round => round.toJSON()),
			venues_by_id = this.options.venues ? _.keyBy(this.options.venues.toJSON(), 'id') : {},
			scheduled_round_id = this.options.rounds.first_scheduled.get('id'),
			last_round_id = last_round.get('id'),
			next_round_id = this.options.rounds.next.id,
			most_recent_round_id = this.options.rounds.most_recent.id,
			has_assistant_coach = User.has_assistant_coach,
			favourites = this.options.favourites.get('list'),
			selected_player = this.options.selected_player;

		this.options.players.each(player => {
			player
				.setFavourite({ favourites })
				.setPositionsName({ positions_by_id })
				.setSquadName({ squad_by_id })
				.setStatsCostDividedByTotalPoints()
				.setOpponent({ squad_by_id, round: actual_round_json })
				.setCostChanges({ round_id: last_completed_round.get('id') })
				.setStatsPointsLastRound({
					is_preseason, rounds,
					round_id: last_round.id
				});

			if (has_assistant_coach) {
				player
					.setCoachStats({
						coach,
						actual_round_id,
						scheduled_round_id,
						last_round_id
					})
					.setFutureGamesStats({
						rounds, coach, squad_by_id,
						venues_by_id, actual_round_id
					})
					.setByRound({ bye_rounds });
			}
		});

		playerComparisonChannel.trigger('show:data', {
			players: this.options.players.toJSON(),
			has_assistant_coach,
			next_round_id,
			squads,
			rounds,
			positions,
			last_round_id,
			actual_round_id,
			scheduled_round_id,
			most_recent_round_id,
			remaining_salary: Number.MAX_SAFE_INTEGER,
			selected_player
		});
	}

	async onFavourite({ currentTarget }) {
		const
			id = parseInt(currentTarget.dataset.id, 10),
			is_favourite = this.options.favourites.get('list').includes(id);

		Preloader.show();

		this.options.favourites.toggle(id);

		playerComparisonChannel.trigger(
			`${is_favourite ? 'remove' : 'add'}:favourite:player`,
			{ player_id: id }
		);

		Preloader.hide();
	}

	removePlayer({ currentTarget }) {
		const
			{ index } = currentTarget.dataset,
			player = this.getRegion('board').currentView.model.get('compare')[index];

		playerComparisonChannel.trigger('removed:player', { player });
	}
}

export default PlayerComparisonMain;